module.exports = __webpack_public_path__ + "img/pic_brazil_08.38f011d6.jpg";